import { ESourceStatuses } from 'entities/Source';
import { i18n } from 'i18n';

export const SOURCE_STATUSES = () => ({
	[ESourceStatuses.NEW]: i18n.t(' Не верифицирована'),
	[ESourceStatuses.ACTIVE]: i18n.t('Подтверждена'),
	[ESourceStatuses.ON_MODERATION]: i18n.t('На модерации'),
	[ESourceStatuses.ON_VERIFICATION]: i18n.t('На верификации'),
	[ESourceStatuses.REJECTED]: i18n.t('Отклонена'),
});
